(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mss-design-system"]) return;
  try {
    
(function(){
  'use strict';
  function init(){
    document.querySelectorAll('[data-mss-products-menu]').forEach(function(menu){
      if(menu.dataset.ready)return;menu.dataset.ready='true';
      menu.addEventListener('keydown',function(event){if(event.key==='Escape'&&menu.open){menu.open=false;menu.querySelector('summary').focus();}});
      document.addEventListener('pointerdown',function(event){if(menu.open&&!menu.contains(event.target))menu.open=false;});
    });
    var dataElement=document.getElementById('MSSVisualData');
    if(!dataElement)return;
    var data;try{data=JSON.parse(dataElement.textContent);}catch(_){return;}
    var strings=document.getElementById('MSSVisualStrings').dataset;
    function figure(key){
      var url=data.assets[key]||data.assets.general;
      var f=document.createElement('figure');f.className='mss-family-figure';
      var img=document.createElement('img');img.src=url+'&width=720';img.alt=strings.alt;img.width=1536;img.height=1024;img.loading='lazy';img.decoding='async';
      var cap=document.createElement('figcaption');cap.textContent=strings.caption;f.append(img,cap);
      img.addEventListener('error',function(){img.remove();},{once:true});return f;
    }
    function browseUrl(category){var p=new URLSearchParams({type:'product','options[unavailable_products]':'show',view:'mss-library',category:category.key,q:category.query});return '/search?'+p.toString();}
    document.querySelectorAll('[data-mss-brands]').forEach(function(section){
      if(section.dataset.ready)return;section.dataset.ready='true';
      var input=section.querySelector('[data-brand-filter]'),letter='',rows=Array.from(section.querySelectorAll('[data-brand-name]'));
      function filter(){var value=input.value.toLocaleLowerCase().replace(/[^a-z0-9]/g,'');var count=0;
        rows.forEach(function(row){var name=row.dataset.brandName;var match=(!letter||name.charAt(0).toUpperCase()===letter)&&name.toLocaleLowerCase().replace(/[^a-z0-9]/g,'').includes(value);row.hidden=!match;if(match)count++;});
        section.querySelector('[data-brand-count]').textContent=strings.count+count;section.querySelector('[data-brand-empty]').hidden=!!count;
      }
      input.addEventListener('input',filter);
      section.querySelectorAll('[data-brand-letter]').forEach(function(button){button.addEventListener('click',function(){letter=button.dataset.brandLetter;section.querySelectorAll('[data-brand-letter]').forEach(function(b){b.setAttribute('aria-pressed',String(b===button));});filter();});});
      filter();
    });
    document.querySelectorAll('[data-mss-brand-search]').forEach(function(form){if(form.dataset.ready)return;form.dataset.ready='true';form.addEventListener('submit',function(){var input=form.querySelector('[name=q]'),brand=form.dataset.brand||'';if(brand&&!input.value.toLowerCase().includes(brand.toLowerCase()))input.value=brand+' '+input.value.trim();});});
    var section=document.querySelector('[data-mss-library-browse]');
    if(section){
      var key=new URLSearchParams(location.search).get('category');var category=data.categories.find(function(c){return c.key===key;});
      if(category){section.querySelector('[data-library-heading]').textContent=category.label;if(category.description)section.querySelector('[data-library-description]').textContent=category.description;
        section.querySelector('[data-library-picture]').replaceChildren(figure(key));var children=section.querySelector('[data-library-children]');
        (category.children||[]).forEach(function(childKey){var child=data.categories.find(function(c){return c.key===childKey;});if(!child)return;var a=document.createElement('a');a.className='mss-subcategory-link';a.href=browseUrl(child);var label=document.createElement('span');label.textContent=child.label+' →';a.append(figure(childKey),label);children.appendChild(a);});
        var rfq=section.querySelector('[data-library-rfq]');if(rfq)rfq.href='/pages/let-us-find-it?query='+encodeURIComponent(category.label);
      }
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mss-home-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mss-home-carousel')) {
  customElements.define('mss-home-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.pauseButton = this.querySelector('[data-pause]');
      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelectorAll('[data-dot]').forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.dot)), options));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('focusin', event => { if (event.target !== this.pauseButton) { this.paused = true; this.sync(); } }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1)); } }, options);
      this.addEventListener('touchstart', event => { this.touchX = event.changedTouches[0].clientX; this.touchY = event.changedTouches[0].clientY; }, {...options,passive:true});
      this.addEventListener('touchend', event => { const dx = event.changedTouches[0].clientX-this.touchX; const dy = event.changedTouches[0].clientY-this.touchY; if (Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)) { this.paused=true; this.show(this.index+(dx<0?1:-1)); this.sync(); } }, {...options,passive:true});
      document.addEventListener('visibilitychange', () => this.sync(), options);
      document.addEventListener('shopify:block:select', event => { const index=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId); if(index>=0){this.paused=true;this.show(index);this.sync();} }, options);
      this.sync();
    }
    show(index) { this.index=(index+this.slides.length)%this.slides.length; this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;}); this.querySelectorAll('[data-dot]').forEach((button,i)=>{if(i===this.index)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');}); }
    sync() { clearInterval(this.timer); this.pauseButton.textContent=this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel; if(!this.paused&&!this.hovered&&!document.hidden)this.timer=setInterval(()=>this.show(this.index+1),8000); }
    disconnectedCallback() { clearInterval(this.timer); if(this.abort)this.abort.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
